
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import { Box, Button, Modal, TextField, Typography } from '@mui/material';
import { getAllAccount } from 'Redux/actions/mobileFinnance';
import { createAccount } from 'Redux/actions/mobileFinnance';
import React from 'react';
import { useDispatch } from 'react-redux';

const AddAccount = ({openAccount,setOpenAccount,style,handleChange,edit,formData}) => {
  const dispatch=useDispatch();
  const handleAccount = async () => {
    let data = {
      number: formData.number,
      balance: formData.balance,
      pin: formData.pin,
      service: formData.service,
    };

    await dispatch(createAccount(data,setOpenAccount));
    await dispatch(getAllAccount(1, 10));
    setOpenAccount(false);
  }
    return (
        <div>
        {<button type="button" id="account1" className={formData.service==='bKash'?"button1":"button11"} onClick={() => setOpenAccount(!openAccount)}>Add</button>}
        <Modal

          open={openAccount}
          onClose={() => setOpenAccount(!openAccount)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Add Account
            </Typography>
            <TextField id="standard-basic" className="input-field" name="number" onChange={handleChange} label="Number" variant="standard" required />
            <TextField id="standard-basic" name="balance" onChange={handleChange} label="Balance" variant="standard" required />
            <TextField id="standard-basic" name="pin" onChange={handleChange} label="Pin" variant="standard" required />
            <br/>
            <Button className="" onClick={handleAccount}>Submit</Button>
          </Box>
        </Modal>


      </div>


)}

export default AddAccount;